import { FamilyApplicationQueries } from '@/queries/family_applications/queries.ts'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { RootState } from '@/storage/store.ts'
import { useSelector } from 'react-redux'
import ApplicantPaymentsView from './ApplicantPaymentsView.tsx'

const ONE_MINUTE = 60 * 1000

export default function ApplicantPaymentsWrapper() {
  const { applicantId } = useParams<{ applicantId?: string }>()
  const { selectedProgramYear } = useSelector((s: RootState) => s.programs)

  const ApplicantData = useQuery(
    FamilyApplicationQueries.getFamilyApplicationById(
      applicantId!,
      selectedProgramYear!.id,
      {
        staleTime: ONE_MINUTE,
        refetchOnMount: true,
      }
    )
  )

  if (!applicantId) {
    return <div>No applicant selected.</div>
  }

  if (ApplicantData.status === 'error') {
    return <div>{ApplicantData.error?.message ?? ''}</div>
  }

  if (ApplicantData.status === 'pending') return <div>Loading</div>

  return <ApplicantPaymentsView ApplicantData={ApplicantData.data} />
}
